module.exports = __webpack_public_path__ + "static/img/preview-06.76fa13f2.webp";